export const widths = {
    medium: '570px',
    large: '808px'
}
